import classNames from "classnames";
import { ReactNode } from "react";

import css from "../profile_card.module.scss";

type ProfileCardActionsRowProps = {
  actions?: ReactNode;
  isColumn?: boolean;
};

export const ProfileCardActionsRow = ({ actions, isColumn }: ProfileCardActionsRowProps) => {
  if (!actions) {
    return null;
  }

  return (
    <>
      <hr className={css.separator} />
      <div className={classNames(css.skillsAndActions, { [css.skillsAndActionsColumn]: isColumn })}>
        {!isColumn && <small> &nbsp;</small>}
        <div className={classNames({ [css.actions]: isColumn })}>{actions}</div>
      </div>
    </>
  );
};
